import * as React from 'react';
import { Carousel } from 'modules/shared-ui-advanced';

import { ProductCarouselProps } from '.';

import styles from './product-carousel-component.module.css';

export const ProductCarousel: React.FC<ProductCarouselProps> = ({ children }: ProductCarouselProps) => {
    return (
        <div className={styles.carouselContainer}>
            <Carousel cards={6} auto dark type="productCarousel">
                {children}
            </Carousel>
        </div>
    );
};
